var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle113(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "356.0179347083227 434.6822239368041 18.205557790617206 19.516656555446616",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M360.03,444.24c.03-2.05.82-3.73,2.56-4.84,1.91-1.22,4.48-.84,6.06.8,1.85,1.92,2.11,5.47.56,7.77-1.31,1.95-3.68,2.73-5.79,1.9-2.21-.87-3.46-2.95-3.4-5.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle113);
export default __webpack_public_path__ + "static/media/twinkle-1-13.07a7a66eaf7ffe5f509c4c0ce136aea8.svg";
export { ForwardRef as ReactComponent };